import { useEffect } from "react";
import * as $ from "jquery";
import useHttp from "../../../hook/use-http";
import { useState } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCityDepo } from "../../../redux/cityDepoSlice";
import ChartLoader from "./ChartLoader";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

export default function PdfFilter_Bus(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
  const [changedColumn, setChangedColumn] = useState("");
  const [columnfilters, setcolumnfilters] = useState([]);
  const [inputValue, setInputValue] = useState(45);
  const [inputSOHValue, setInputSOHValue] = useState(100);
  const [sohSelectedDate, setSohSelectedDate] = useState(
    moment().subtract(1, "days").toDate()
  );

  const excelDate = moment(new Date(sohSelectedDate)).format("YYYY-MM-DD");

  const cityDepoAccess = useSelector(selectCityDepo);
  // code to get city_depo from redux

  const [refreshDate, setRefreshDate] = useState("");

  useEffect(() => {
    fetchData(
      {
        url:
          API_URL_MAIN + "energy_analysis_bus/energy_analysis_refreshdate_bus",
        body: {},
      },
      refreshDateData
    );
  }, []);

  const refreshDateData = (data) => {
    setRefreshDate(data.value_as_string);
  };

  const startDateChanged = (date) => {
    let sDate = "startDate";
    setChangedColumn("startDate");
    setFilterData((prestate) => {
      return { ...filterdata, [sDate]: date };
    });
    if (columnfilters.indexOf("START_DATE") === -1) {
      setcolumnfilters([...columnfilters, "START_DATE"]);
    }
  };

  const endDateChanged = (date) => {
    let eDate = "endDate";
    setChangedColumn("endDate");
    setFilterData((prestate) => {
      return { ...filterdata, [eDate]: date };
    });
    if (columnfilters.indexOf("END_DATE") === -1) {
      setcolumnfilters([...columnfilters, "END_DATE"]);
    }
  };

  const sohDateChanged = (date) => {
    setCsvData([]);
    setSohSelectedDate(date);
  };

  const [maxTempErrMsg, setmaxTempErrMsg] = useState("");
  const [showDownloadButton, setShowDownloadButton] = useState(false);
  // const [showLoader, setShowLoader] = useState(false);
  const [maxSOHErrMsg, setmaxSOHErrMsg] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [csvChargeData, setCsvChargeData] = useState([]);
  const [buttonClicked, setButtonClicked] = useState(false);

  const onsubmit = (e) => {
    setmaxTempErrMsg("");
    e.preventDefault();
    if (inputValue >= 44) {
      props.onsubmit(filterdata);
      setShowDownloadButton(true);
      setTimeout(() => {
        onDownload({});
      }, 6000);
    } else {
      setmaxTempErrMsg("Max Temp must be greater 43.");
    }
  };

  const onSOHsubmit = async (e) => {
    await setCsvData([]);
    setmaxSOHErrMsg("");
    e.preventDefault();
    if (inputSOHValue <= 100) {
      await fetchData(
        {
          url: API_URL_MAIN + "pdf_bus/soh_excel_download",
          body: { sohSelectedDate: sohSelectedDate, inputSOHValue },
        },
        responceBarData
      );
      await fetchData(
        {
          url: API_URL_MAIN + "pdf_bus/soh_charge_excel_download",
          body: { sohSelectedDate: sohSelectedDate, inputSOHValue },
        },
        responceBarChargeData
      );
      await fetchData(
        {
          url: API_URL_MAIN + "auth/logging",
          body: {
            page_name: "download_soh_report",
          },
        },
        log_data
      );
      // await setTimeout(() => {
      //   exportToExcel();
      // }, 4000);
      // await exportToExcel();
      await setButtonClicked(true);
    } else {
      setmaxSOHErrMsg("SOH must be less than or equal to 100.");
    }
  };

  // useEffect(() => {
  //   // if (buttonClicked === true) {
  //   setCsvData([]);
  //   fetchData(
  //     {
  //       url: API_URL_MAIN + "pdf_bus/soh_excel_download",
  //       body: { sohSelectedDate: sohSelectedDate, inputSOHValue },
  //     },
  //     responceBarData
  //   );
  //   fetchData(
  //     {
  //       url: API_URL_MAIN + "pdf_bus/soh_charge_excel_download",
  //       body: { sohSelectedDate: sohSelectedDate, inputSOHValue },
  //     },
  //     responceBarChargeData
  //   );
  //   // }
  // }, []);

  // useEffect(() => {
  //   // if (buttonClicked === true) {
  //   setCsvData([]);
  //   fetchData(
  //     {
  //       url: API_URL_MAIN + "pdf_bus/soh_excel_download",
  //       body: { sohSelectedDate: sohSelectedDate, inputSOHValue },
  //     },
  //     responceBarData
  //   );
  //   // }
  // }, [sohSelectedDate, inputSOHValue]);

  const responceBarData = (data) => {
    setCsvData(data);
  };
  const responceBarChargeData = (data) => {
    setCsvChargeData(data);
  };

  const handleInputChange = (e) => {
    setInputValue(parseInt(e.target.value, 10));
    props.onpack(parseInt(e.target.value, 10));
  };

  const handleInputSOHChange = (e) => {
    // console.log("");
    setCsvData([]);
    // setInputSOHValue(parseInt(e.target.value, 10));
    setInputSOHValue(parseFloat(e.target.value, 10));
  };

  const onDownload = async (e) => {
    props.buttonClicked("true");
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "download_performance_report",
        },
      },
      log_data
    );
    setShowDownloadButton(false);
    props?.setShowLoader(true);
    setTimeout(() => {
      // setShowLoader(false);
    }, 4000);
  };

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const excelFileName = `SOH_${excelDate}_${inputSOHValue}`;

  // const exportToExcel = async () => {
  //   const flatData = csvData.map((item) => ({
  //     vehicleId: item._source.vehicleId,
  //     A_SOH_Value: item._source.A_SOH_Value,
  //     B_SOH_Value: item._source.B_SOH_Value,
  //     C_SOH_Value: item._source.C_SOH_Value,
  //     D_SOH_Value: item._source.D_SOH_Value,
  //     "Min SOH": item._source.min_value,
  //     // "Median of Max_Pack A Charge Temp":
  //     //   item._source.Median_of_Max_Pack_A_Charge_Temp,
  //     "Median of Max_Pack A Charge Temp": csvChargeData
  //       ? csvChargeData.A_Max_Cell_Temp.values["50.0"]
  //       : "-",
  //     "Median of Max_Pack B Charge Temp":
  //       item._source.Median_of_Max_Pack_B_Charge_Temp,
  //     "Median of Max_Pack C Charge Temp":
  //       item._source.Median_of_Max_Pack_C_Charge_Temp,
  //     "Median of Max_Pack D Charge Temp":
  //       item._source.Median_of_Max_Pack_D_Charge_Temp,
  //     "Median of Max_Pack A Discharge Temp":
  //       item._source.Median_of_Max_Pack_A_Discharge_Temp,
  //     "Median of Max_Pack B Discharge Temp":
  //       item._source.Median_of_Max_Pack_B_Discharge_Temp,
  //     "Median of Max_Pack C Discharge Temp":
  //       item._source.Median_of_Max_Pack_C_Discharge_Temp,
  //     "Median of Max_Pack D Discharge Temp":
  //       item._source.Median_of_Max_Pack_D_Discharge_Temp,
  //     "Avg of_Pack A Charge Temp": item._source.Avg_of_Pack_A_Charge_Temp,
  //     "Avg of_Pack B Charge Temp": item._source.Avg_of_Pack_B_Charge_Temp,
  //     "Avg of_Pack C Charge Temp": item._source.Avg_of_Pack_C_Charge_Temp,
  //     "Avg of_Pack D Charge Temp": item._source.Avg_of_Pack_D_Charge_Temp,
  //     "Avg of_Pack A Discharge Temp": item._source.Avg_of_Pack_A_Discharge_Temp,
  //     "Avg of_Pack B Discharge Temp": item._source.Avg_of_Pack_B_Discharge_Temp,
  //     "Avg of_Pack C Discharge Temp": item._source.Avg_of_Pack_C_Discharge_Temp,
  //     "Avg of_Pack D Discharge Temp": item._source.Avg_of_Pack_D_Discharge_Temp,
  //     "Pack A Total KWH Charged": item._source.Pack_A_Total_KWH_Charged,
  //     "Pack B Total KWH Charged": item._source.Pack_B_Total_KWH_Charged,
  //     "Pack C Total KWH Charged": item._source.Pack_C_Total_KWH_Charged,
  //     "Pack D Total KWH Charged": item._source.Pack_D_Total_KWH_Charged,
  //     "Pack A Total KWH Discharged": item._source.Pack_A_Total_KWH_Discharged,
  //     "Pack B Total KWH Discharged": item._source.Pack_B_Total_KWH_Discharged,
  //     "Pack C Total KWH Discharged": item._source.Pack_C_Total_KWH_Discharged,
  //     "Pack D Total KWH Discharged": item._source.Pack_D_Total_KWH_Discharged,
  //     "Total KWH Charged": item._source.kwhCharged_cycles,
  //     "Total KWH Discharged": item._source.NetkWh,
  //     endOdo: item._source.endOdo,
  //     total_charged_cycle: item._source.total_charged_cycle,
  //     total_full_charged_cycles: item._source.total_full_charged_cycles,
  //     Net_consumption: item._source.Net_consumption,
  //     Energy_consumption: item._source.Energy_consumption,
  //     Regeneration: item._source.Regeneration,
  //     Regeneration_fraction: item._source.Regeneration_fraction,
  //     Depot_Name: item._source.Depot_Name,
  //     DLR_ORG_CITY: item._source.DLR_ORG_CITY,
  //     PL: item._source.PL,
  //     PPL: item._source.PPL,
  //     LOB: item._source.LOB,
  //     "Vehicle Type": item._source.vehicle_type,
  //     "AC/Non AC": item._source.air_ventilation,
  //   }));

  //   const ws = XLSX.utils.json_to_sheet(flatData);
  //   const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], { type: fileType });
  //   FileSaver.saveAs(data, excelFileName + fileExtension);

  //   // fetchData({ url: API_URL_MAIN + "auth/logging", body: { page_name: "Action_data_off_down" } }, [])
  // };

  // const exportToExcel = async () => {
  //   const flatData = csvData.map((item) => {
  //     const chargeData = csvChargeData.find(
  //       (chargeItem) => item._source.vehicleId === chargeItem.key.vehicleId
  //     );

  //     return {
  //       // "B_Max_Cell_Temp (50.0)":
  //       //   chargeData && chargeData.B_Max_Cell_Temp.values["50.0"] !== null
  //       //     ? chargeData.B_Max_Cell_Temp.values["50.0"]
  //       //     : "-",
  //       // "A_Max_Cell_Temp (50.0)":
  //       //   chargeData && chargeData.A_Max_Cell_Temp.values["50.0"] !== null
  //       //     ? chargeData.A_Max_Cell_Temp.values["50.0"]
  //       //     : "-",
  //       // "D_Max_Cell_Temp (50.0)":
  //       //   chargeData && chargeData.D_Max_Cell_Temp.values["50.0"] !== null
  //       //     ? chargeData.D_Max_Cell_Temp.values["50.0"]
  //       //     : "-",
  //       // "C_Max_Cell_Temp (50.0)":
  //       //   chargeData && chargeData.C_Max_Cell_Temp.values["50.0"] !== null
  //       //     ? chargeData.C_Max_Cell_Temp.values["50.0"]
  //       //     : "-",
  //       vehicleId: item._source.vehicleId,
  //       A_SOH_Value: item._source.A_SOH_Value,
  //       B_SOH_Value: item._source.B_SOH_Value,
  //       C_SOH_Value: item._source.C_SOH_Value,
  //       D_SOH_Value: item._source.D_SOH_Value,
  //       "Min SOH": item._source.min_value,
  //       // "Median of Max_Pack A Charge Temp":
  //       //   item._source.Median_of_Max_Pack_A_Charge_Temp,
  //       "Median of Max_Pack A Charge Temp":
  //         chargeData && chargeData.A_Max_Cell_Temp.values["50.0"] !== null
  //           ? chargeData.A_Max_Cell_Temp.values["50.0"]
  //           : "-",
  //       "Median of Max_Pack B Charge Temp":
  //         chargeData && chargeData.B_Max_Cell_Temp.values["50.0"] !== null
  //           ? chargeData.B_Max_Cell_Temp.values["50.0"]
  //           : "-",
  //       "Median of Max_Pack C Charge Temp":
  //         chargeData && chargeData.C_Max_Cell_Temp.values["50.0"] !== null
  //           ? chargeData.C_Max_Cell_Temp.values["50.0"]
  //           : "-",
  //       "Median of Max_Pack D Charge Temp":
  //         chargeData && chargeData.D_Max_Cell_Temp.values["50.0"] !== null
  //           ? chargeData.D_Max_Cell_Temp.values["50.0"]
  //           : "-",
  //       "Median of Max_Pack A Discharge Temp":
  //         item._source.Median_of_Max_Pack_A_Discharge_Temp,
  //       "Median of Max_Pack B Discharge Temp":
  //         item._source.Median_of_Max_Pack_B_Discharge_Temp,
  //       "Median of Max_Pack C Discharge Temp":
  //         item._source.Median_of_Max_Pack_C_Discharge_Temp,
  //       "Median of Max_Pack D Discharge Temp":
  //         item._source.Median_of_Max_Pack_D_Discharge_Temp,
  //       "Avg of_Pack A Charge Temp": item._source.Avg_of_Pack_A_Charge_Temp,
  //       "Avg of_Pack B Charge Temp": item._source.Avg_of_Pack_B_Charge_Temp,
  //       "Avg of_Pack C Charge Temp": item._source.Avg_of_Pack_C_Charge_Temp,
  //       "Avg of_Pack D Charge Temp": item._source.Avg_of_Pack_D_Charge_Temp,
  //       "Avg of_Pack A Discharge Temp":
  //         item._source.Avg_of_Pack_A_Discharge_Temp,
  //       "Avg of_Pack B Discharge Temp":
  //         item._source.Avg_of_Pack_B_Discharge_Temp,
  //       "Avg of_Pack C Discharge Temp":
  //         item._source.Avg_of_Pack_C_Discharge_Temp,
  //       "Avg of_Pack D Discharge Temp":
  //         item._source.Avg_of_Pack_D_Discharge_Temp,
  //       "Pack A Total KWH Charged": item._source.Pack_A_Total_KWH_Charged,
  //       "Pack B Total KWH Charged": item._source.Pack_B_Total_KWH_Charged,
  //       "Pack C Total KWH Charged": item._source.Pack_C_Total_KWH_Charged,
  //       "Pack D Total KWH Charged": item._source.Pack_D_Total_KWH_Charged,
  //       "Pack A Total KWH Discharged": item._source.Pack_A_Total_KWH_Discharged,
  //       "Pack B Total KWH Discharged": item._source.Pack_B_Total_KWH_Discharged,
  //       "Pack C Total KWH Discharged": item._source.Pack_C_Total_KWH_Discharged,
  //       "Pack D Total KWH Discharged": item._source.Pack_D_Total_KWH_Discharged,
  //       "Total KWH Charged": item._source.kwhCharged_cycles,
  //       "Total KWH Discharged": item._source.NetkWh,
  //       endOdo: item._source.endOdo,
  //       total_charged_cycle: item._source.total_charged_cycle,
  //       total_full_charged_cycles: item._source.total_full_charged_cycles,
  //       Net_consumption: item._source.Net_consumption,
  //       Energy_consumption: item._source.Energy_consumption,
  //       Regeneration: item._source.Regeneration,
  //       Regeneration_fraction: item._source.Regeneration_fraction,
  //       Depot_Name: item._source.Depot_Name,
  //       DLR_ORG_CITY: item._source.DLR_ORG_CITY,
  //       PL: item._source.PL,
  //       PPL: item._source.PPL,
  //       LOB: item._source.LOB,
  //       "Vehicle Type": item._source.vehicle_type,
  //       "AC/Non AC": item._source.air_ventilation,
  //     };
  //   });

  //   const ws = XLSX.utils.json_to_sheet(flatData);
  //   const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], { type: fileType });
  //   FileSaver.saveAs(data, excelFileName + fileExtension);
  // };

  useEffect(() => {
    if (buttonClicked === true) {
      const flatData = csvData.map((item) => {
        const chargeData = csvChargeData.find(
          (chargeItem) => item._source.vehicleId === chargeItem.key.vehicleId
        );

        return {
          // "B_Max_Cell_Temp (50.0)":
          //   chargeData && chargeData.B_Max_Cell_Temp.values["50.0"] !== null
          //     ? chargeData.B_Max_Cell_Temp.values["50.0"]
          //     : "-",
          // "A_Max_Cell_Temp (50.0)":
          //   chargeData && chargeData.A_Max_Cell_Temp.values["50.0"] !== null
          //     ? chargeData.A_Max_Cell_Temp.values["50.0"]
          //     : "-",
          // "D_Max_Cell_Temp (50.0)":
          //   chargeData && chargeData.D_Max_Cell_Temp.values["50.0"] !== null
          //     ? chargeData.D_Max_Cell_Temp.values["50.0"]
          //     : "-",
          // "C_Max_Cell_Temp (50.0)":
          //   chargeData && chargeData.C_Max_Cell_Temp.values["50.0"] !== null
          //     ? chargeData.C_Max_Cell_Temp.values["50.0"]
          //     : "-",
          vehicleId: item._source.vehicleId,
          A_SOH_Value: item._source.A_SOH_Value,
          B_SOH_Value: item._source.B_SOH_Value,
          C_SOH_Value: item._source.C_SOH_Value,
          D_SOH_Value: item._source.D_SOH_Value,
          "Min SOH": item._source.min_value,
          // "Median of Max_Pack A Charge Temp":
          //   item._source.Median_of_Max_Pack_A_Charge_Temp,
          "Median of Max_Pack A Charge Temp":
            chargeData && chargeData.A_Max_Cell_Temp.values["50.0"] !== null
              ? chargeData.A_Max_Cell_Temp.values["50.0"]
              : "-",
          "Median of Max_Pack B Charge Temp":
            chargeData && chargeData.B_Max_Cell_Temp.values["50.0"] !== null
              ? chargeData.B_Max_Cell_Temp.values["50.0"]
              : "-",
          "Median of Max_Pack C Charge Temp":
            chargeData && chargeData.C_Max_Cell_Temp.values["50.0"] !== null
              ? chargeData.C_Max_Cell_Temp.values["50.0"]
              : "-",
          "Median of Max_Pack D Charge Temp":
            chargeData && chargeData.D_Max_Cell_Temp.values["50.0"] !== null
              ? chargeData.D_Max_Cell_Temp.values["50.0"]
              : "-",
          "Median of Max_Pack A Discharge Temp":
            item._source.Median_of_Max_Pack_A_Discharge_Temp,
          "Median of Max_Pack B Discharge Temp":
            item._source.Median_of_Max_Pack_B_Discharge_Temp,
          "Median of Max_Pack C Discharge Temp":
            item._source.Median_of_Max_Pack_C_Discharge_Temp,
          "Median of Max_Pack D Discharge Temp":
            item._source.Median_of_Max_Pack_D_Discharge_Temp,
          "Avg of_Pack A Charge Temp": item._source.Avg_of_Pack_A_Charge_Temp,
          "Avg of_Pack B Charge Temp": item._source.Avg_of_Pack_B_Charge_Temp,
          "Avg of_Pack C Charge Temp": item._source.Avg_of_Pack_C_Charge_Temp,
          "Avg of_Pack D Charge Temp": item._source.Avg_of_Pack_D_Charge_Temp,
          "Avg of_Pack A Discharge Temp":
            item._source.Avg_of_Pack_A_Discharge_Temp,
          "Avg of_Pack B Discharge Temp":
            item._source.Avg_of_Pack_B_Discharge_Temp,
          "Avg of_Pack C Discharge Temp":
            item._source.Avg_of_Pack_C_Discharge_Temp,
          "Avg of_Pack D Discharge Temp":
            item._source.Avg_of_Pack_D_Discharge_Temp,
          "Pack A Total KWH Charged": item._source.Pack_A_Total_KWH_Charged,
          "Pack B Total KWH Charged": item._source.Pack_B_Total_KWH_Charged,
          "Pack C Total KWH Charged": item._source.Pack_C_Total_KWH_Charged,
          "Pack D Total KWH Charged": item._source.Pack_D_Total_KWH_Charged,
          "Pack A Total KWH Discharged":
            item._source.Pack_A_Total_KWH_Discharged,
          "Pack B Total KWH Discharged":
            item._source.Pack_B_Total_KWH_Discharged,
          "Pack C Total KWH Discharged":
            item._source.Pack_C_Total_KWH_Discharged,
          "Pack D Total KWH Discharged":
            item._source.Pack_D_Total_KWH_Discharged,
          "Total KWH Charged": item._source.kwhCharged_cycles,
          "Total KWH Discharged": item._source.NetkWh,
          endOdo: item._source.endOdo,
          total_charged_cycle: item._source.total_charged_cycle,
          total_full_charged_cycles: item._source.total_full_charged_cycles,
          Net_consumption: item._source.Net_consumption,
          Energy_consumption: item._source.Energy_consumption,
          Regeneration: item._source.Regeneration,
          Regeneration_fraction: item._source.Regeneration_fraction,
          Depot_Name: item._source.Depot_Name,
          DLR_ORG_CITY: item._source.DLR_ORG_CITY,
          PL: item._source.PL,
          PPL: item._source.PPL,
          LOB: item._source.LOB,
          "Vehicle Type": item._source.vehicle_type,
          "AC/Non AC": item._source.air_ventilation,
        };
      });

      const ws = XLSX.utils.json_to_sheet(flatData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, excelFileName + fileExtension);
    }
    setButtonClicked(false);
  }, [buttonClicked]);

  const log_data = (data) => { };

  return (
    <>
      <div className="row pt-3">
        <div className="col-md-4"></div>
        <div
          className="col-md-4"
          style={{
            border: "2px solid #a7a7a7",
            borderRadius: "5px",
            backgroundColor: "#fff",
          }}
        >
          <div className="row">
            <span
              className=""
              style={{
                backgroundColor: "#83A4CF",
                fontWeight: "bold",
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                color: "#fff",
                height: "35px",
              }}
            >
              Trend Analysis Report
            </span>
          </div>
          <form className="g-3 mt-2 filterForm">
            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-lg-5 col-md-6 col-sm-12">
                <div className="mb-3">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label_bus"
                  >
                    Start Date
                  </label>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    minDate={moment(
                      new Date("2023-08-15T00:00:00.000Z")
                    ).toDate()}
                    maxDate={moment().subtract(1, "days").toDate()}
                    selected={filterdata.startDate}
                    onChange={startDateChanged}
                  />
                </div>
              </div>

              <div className="col-lg-5 col-md-6 col-sm-12">
                <div className="mb-3">
                  <label
                    htmlFor="exampleFormControlInput2"
                    className="form-label_bus"
                  >
                    End Date
                  </label>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    minDate={moment(
                      new Date("2023-08-15T00:00:00.000Z")
                    ).toDate()}
                    maxDate={moment().subtract(1, "days").toDate()}
                    selected={filterdata.endDate}
                    onChange={endDateChanged}
                  />
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-1"></div>
              <div className="col-md-5">
                <label
                  htmlFor="exampleFormControlInput2"
                  className="form-label_bus"
                >
                  Max Temp.
                </label>
                <input
                  type="text"
                  defaultValue={45}
                  style={{ width: "150px", height: "36px", display: "flex" }}
                  onChange={handleInputChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
                {maxTempErrMsg.length > 0 && (
                  <p
                    className="text-danger"
                    style={{
                      fontSize: "10px",
                      marginTop: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    {maxTempErrMsg}
                  </p>
                )}
              </div>
              {/* <div className='col-md-5'></div> */}
            </div>

            <div className="row mb-4 mt-4 pt-2 pb-2">
              <div className="col-md-1"></div>
              <div className="col-md-5" style={{ paddingLeft: "10px" }}>
                <label className="form-label_bus" />
                <button
                  type="submit"
                  className="form-control btn btn_pdf "
                  onClick={onsubmit}
                  style={{ color: "#fff" }}
                >
                  Download
                </button>
              </div>
              {showDownloadButton && (
                <div className="col-md-5" style={{ visibility: "hidden" }}>
                  <label className="form-label_bus" />
                  <button
                    type="button"
                    className="form-control btn btn_pdf "
                    onClick={onDownload}
                    style={{ color: "#fff" }}
                  >
                    Download
                  </button>
                </div>
              )}
              {props?.showLoader && (
                <div className="col-md-5">
                  <ChartLoader />
                </div>
              )}
            </div>
          </form>
          <div className="row">
            <div className="col text-start">
              <span
                className="text-start"
                style={{ color: "red", fontSize: "12px", fontWeight: "bolder" }}
              >
                Note :{" "}
              </span>
              <span className="text-end" style={{ fontSize: "12px" }}>
                Please keep your window size at 100%.
              </span>
            </div>
          </div>
        </div>
        <div className="col-md-4"></div>

        <div className="col-md-4"></div>
        <div
          className="col-md-4 mt-2"
          style={{
            border: "2px solid #a7a7a7",
            borderRadius: "5px",
            backgroundColor: "#fff",
          }}
        >
          <div className="row">
            <span
              className=""
              style={{
                backgroundColor: "#83A4CF",
                fontWeight: "bold",
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                color: "#fff",
                height: "35px",
              }}
            >
              SOH Report
            </span>
          </div>

          <form className="g-3 mt-2 filterForm">
            <div className="row">
              {/* <div className="col-md-1"></div> */}
              <div className="col-md-4">
                <div className="mb-3">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label_bus"
                  >
                    Select Date
                  </label>
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    minDate={moment(
                      new Date("2023-08-15T00:00:00.000Z")
                    ).toDate()}
                    maxDate={moment().subtract(1, "days").toDate()}
                    selected={sohSelectedDate}
                    onChange={sohDateChanged}
                  />
                </div>
              </div>

              <div className="col-md-4 ">
                <label
                  htmlFor="exampleFormControlInput2"
                  className="form-label_bus"
                >
                  SOH
                </label>
                {/* <input
                  type="number"
                  step="0.1"
                  max={100}
                  defaultValue={100}
                  style={{ height: "36px", display: "flex", width: "112px" }}
                  onChange={handleInputSOHChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
                  }
                /> */}

                <input
                  type="text"
                  // step="0.1"
                  max={100}
                  defaultValue={100}
                  style={{ height: "36px", display: "flex", width: "112px" }}
                  onChange={handleInputSOHChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
                  }
                />
                {maxSOHErrMsg.length > 0 && (
                  <p
                    className="text-danger"
                    style={{
                      fontSize: "10px",
                      marginTop: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    {maxSOHErrMsg}
                  </p>
                )}
              </div>

              <div className="col-md-4">
                <div className="row pt-1 mt-3 pb-1">
                  <div className="col-md-1"></div>
                  <div className="col" style={{ paddingLeft: "10px" }}>
                    <label className="form-label_bus" />
                    {/* {csvData.length > 0 && ( */}
                    <button
                      type="submit"
                      className="form-control btn btn_pdf "
                      onClick={onSOHsubmit}
                      style={{ color: "#fff" }}
                    >
                      Download
                    </button>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </form>

          {/* <div className="row">
            <div className="col text-start">
              <span
                className="text-start"
                style={{ color: "red", fontSize: "12px", fontWeight: "bolder" }}
              >
                Note :{" "}
              </span>
              <span className="text-end" style={{ fontSize: "12px" }}>
                Please keep your window size at 100%.
              </span>
            </div>
          </div> */}
        </div>

        <div className="col-md-4"></div>
      </div>
    </>
  );
}
